<mat-expansion-panel [expanded]="true" hideToggle >
    <mat-expansion-panel-header class='header' style="pointer-events: none;">
      <mat-panel-description>
        {{title}}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayoutAlign="center">
      <p class="mt-3 mb-3 breakline">{{errorMessage}}</p>
    </div>
    <div fxLayoutAlign="center">
      <button class="grey-button" mat-raised-button (click)="closeMe('yes')">Yes</button>
      <button class="grey-button" style="margin-left: 10px" mat-raised-button (click)="closeMe('no')">No</button>
    </div>
  </mat-expansion-panel>